import set from "date-fns/fp/set/index";
import { call, put, takeLatest } from "redux-saga/effects";
import { getAllProjectManagementDetails } from "../http/requests/project-management";
import {
  setVtrackLoader
} from "../redux/actions";
import { ProjectManagementType, setAllProjectManagementData } from "../redux/actions/project-management";

function* workerAllProjectManagementSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    
    // 🔍 DEBUG: Log what API call we're making
    console.log('🔍 Calling ProjectManagement API only...');
    
    // Call the ProjectManagement API to get the main data
    const allProjectManagementDetails = yield call(getAllProjectManagementDetails);
    
    // 🔍 DEBUG: Log the API response
    console.log('🔍 ProjectManagement API Response:', {
      hasData: !!allProjectManagementDetails?.data,
      dataLength: allProjectManagementDetails?.data?.length || 0,
      firstRecord: allProjectManagementDetails?.data?.[0],
      sampleFields: Object.keys(allProjectManagementDetails?.data?.[0] || {}),
      fullResponse: allProjectManagementDetails
    });
    
    // 🔍 DEBUG: Specifically check for date fields in the first record
    if (allProjectManagementDetails?.data?.[0]) {
      const firstRecord = allProjectManagementDetails.data[0];
      console.log('🔍 FIRST RECORD ANALYSIS:');
      console.log('🔍 All fields in first record:', Object.keys(firstRecord));
      
      // Look for date-related fields
      const dateFields = Object.keys(firstRecord).filter(key => 
        key.toLowerCase().includes('date') || 
        key.toLowerCase().includes('end') ||
        key.toLowerCase().includes('allocation')
      );
      
      console.log('🔍 Date-related fields found:', dateFields.map(field => ({
        field: field,
        value: firstRecord[field],
        type: typeof firstRecord[field]
      })));
      
      // Specifically check for lastAllocationEndDate variations
      console.log('🔍 LastAllocationEndDate field variations:');
      console.log('  lastAllocationEndDate:', firstRecord.lastAllocationEndDate);
      console.log('  LastAllocationEndDate:', firstRecord.LastAllocationEndDate);
      console.log('  last_allocation_end_date:', firstRecord.last_allocation_end_date);
      console.log('  endDate:', firstRecord.endDate);
      console.log('  EndDate:', firstRecord.EndDate);
    }
    
    yield put(setAllProjectManagementData(allProjectManagementDetails));
    yield put(setVtrackLoader(false));
  } catch (err) {
    console.log('❌ Error in workerAllProjectManagementSaga:', err);
    yield put(setVtrackLoader(false));
  }
};

export function* allProjectManagementSaga() {
  yield takeLatest(
    ProjectManagementType.GET_ALL_PROJECT_MANAGEMENT_DATA,
    workerAllProjectManagementSaga
  );
};
